import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NotificationSetting = React.lazy(() =>
    import('../NotificationSetting')
);
const notificationSettingRoutesRegistry = [
    {
        path: PAGE_URL.NOTIFICATION_SETTING_PAGE,
        element: <NotificationSetting />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default notificationSettingRoutesRegistry;
